import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PrivateRoute from 'src/routes/PrivateRoute';
import NotFound from 'src/pages/NotFound';
import Login from 'src/pages/Login';
import Dashboard from 'src/pages/Dashboard';
import Comics from 'src/pages/Comics';
import Genres from 'src/pages/Genres';
import PreviewChapter from 'src/pages/PreviewChapter';
import Users from 'src/pages/Users';
import Settings from 'src/pages/Settings';
import Profile from 'src/pages/Profile';

const RoutesContainer = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="*" element={<NotFound />} />
        <Route path="/" element={<Login />} />
        <Route path="dashboard/*" element={<PrivateRoute privateElement={<Dashboard />} />}>
          <Route path="comics" element={<Comics />} />
          <Route path="genres" element={<Genres />} />
          <Route path="users" element={<Users />} />
          <Route path="settings" element={<Settings />} />
          <Route path="profile" element={<PrivateRoute privateElement={<Profile />} />} />
        </Route>
        <Route path="preview" element={<PrivateRoute privateElement={<PreviewChapter />} />} />
      </Routes>
    </BrowserRouter>
  )
}

export default RoutesContainer;